/**
 * SizilPro — AppShell
 * Top-level layout: sidebar + topbar + content area.
 * Wraps every authenticated route.
 */

import { type ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { useUiStore } from "@/store/uiStore";
import { cn } from "@/lib/utils";

interface Props {
  children: ReactNode;
}

export function AppShell({ children }: Props) {
  const sidebarOpen = useUiStore((s) => s.sidebarOpen);

  return (
    <div className="flex h-screen bg-[#0f0f0f] text-white overflow-hidden">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <div
        className={cn(
          "flex-1 flex flex-col min-w-0 transition-all duration-200",
          sidebarOpen ? "ml-56" : "ml-14"
        )}
      >
        <main className="flex-1 overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  );
}
